import React from "react";

import { Theme } from "consts";
import { useMain } from "screens/main/hooks";

import ThemeA from "./themeA";
import ThemeB from "./themeB";

const Main = () => {
  const props = useMain();
  const MainScreenTheme = themes[props.survey.questionnaire?.theme] || ThemeA;
  return <MainScreenTheme {...props} />;
};

export default Main;

const themes = {
  [Theme.RETRO]: ThemeA,
  [Theme.MODERN]: ThemeB,
};
